import { render, staticRenderFns } from "./SaleItemsList.vue?vue&type=template&id=78f3f2a4"
import script from "./SaleItemsList.vue?vue&type=script&lang=js"
export * from "./SaleItemsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports